<script>
export default {
    name: "Easy"
}
</script>

<template>
<section class="easy">
   <h2>{{__('Почему игроки и авторы выбирают нас?')}}</h2>
    <div class="easy-wrapper-container">
    <div class="easy-wrapper">
        <div class="max-box-container-first">
            <div class="es-box-title">{{__('Интерфейс')}}</div>
            <div class="es-box-desc">{{__('Мы с нуля разработали визуально приятный и интуитивно понятный интерфейс приложения, чтобы процесс установки игровых модификаций был максимально лёгким и доступным.')}}</div>
        </div>
        <div class="min-box-container-first">
            <div class="es-box-title">{{__('Автоустановка')}}</div>
            <div class="es-box-desc">{{__('Приложение Cloud Mods установит понравившуюся Вам модификацию для любой поддерживаемой игры.')}}</div>
        </div>
    </div>
    <div class="easy-wrapper">
        <div class="med-box-container-first">
            <div class="es-box-title">{{__('Библиотека')}}</div>
            <div class="es-box-desc">{{__('Наше приложение содержит огромную библиотеку, которая на данный момент насчитывает более 32 451 модификации, доступных для установки.')}}</div>
        </div>
        <div class="med-box-container-second">
            <div class="es-box-title">{{__('Монетизация')}}</div>
            <div class="es-box-desc">{{__('С нами авторы игровых модификаций зарабатывают на своём труде, мы помогаем им с продвижением их работ, а игроки делятся своим мнением.')}}</div>
        </div>
    </div>
    <div class="easy-wrapper">
        <div class="min-box-container-second">
            <div class="es-box-title">{{__('Игры')}}</div>
            <div class="es-box-desc">{{__('Cloud Mods поддерживает сразу несколько игр, на данный момент это GTA V, Minecraft и ETS 2.')}}</div>
        </div>
        <div class="max-box-container-second">
            <div class="es-box-title">{{__('Подписка')}}</div>
            <div class="es-box-desc">{{__('Подписка Cloud Premium открывает доступ к всей библиотеке модификаций в приложении и для всех игр поддерживающих пользовательские модификации. Это максимально выгодно и удобно.')}}</div>
        </div>
    </div>
    </div>
</section>
</template>

<style scoped>
.easy {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    width: 100%;

    position: relative;
    background-repeat: no-repeat;
    background-position: center;
}

.easy-wrapper {
    display: flex;
    flex-direction: row;
}

.easy-wrapper-container {
    display: flex;
    flex-direction: column;
}

h2 {
    margin: 0;
    font-style: normal;
    font-weight: 600;
}

.max-box-container-first, .max-box-container-second {
    display: flex;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.med-box-container-first, .med-box-container-second {
    display: flex;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.min-box-container-first, .min-box-container-second {
    display: flex;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.es-box-title {
    font-weight: 600;
    color: var(--text-primary);
}

.es-box-desc {
    width: 100%;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.60);
}

.max-box-container-first:hover, .med-box-container-first:hover, .min-box-container-second:hover {
    transform: rotateX(-7.5deg) rotateY(5deg);
}

.min-box-container-first:hover, .med-box-container-second:hover, .max-box-container-second:hover {
    transform: rotateX(7.5deg) rotateY(10deg);
}

@media (min-width: 320px) {
    .easy {
        height: 570.625vw;

        gap: 5vw;
    }

    .easy-wrapper {
        gap: 3.125vw;
    }

    .easy-wrapper {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        gap: 3.125vw;
    }

    .es-box-title {
        text-align: center;
        font-size: 4.6875vw;
    }

    .es-box-desc {
        text-align: center;
        font-size: 3.75vw;
    }

    .max-box-container-first, .med-box-container-first, .min-box-container-first, .max-box-container-second, .med-box-container-second, .min-box-container-second {
        gap: 3.125vw;
        border-radius: 3.75vw;
        border: 1px solid #222222;
        transition: 0.3s ease;
    }

    .max-box-container-first {
        background-image: url("@/assets/images/benefits/app_320.png");
    }

    .max-box-container-second {
        background-image: url("@/assets/images/benefits/subs_320.png");
    }

    .med-box-container-first {
        background-image: url("@/assets/images/benefits/library_320.png");
    }

    .med-box-container-second {
        background-image: url("@/assets/images/benefits/money_320.png");
    }

    .min-box-container-first {
        background-image: url("@/assets/images/benefits/autoinstall_320.png");
    }

    .min-box-container-second {
        background-image: url("@/assets/images/benefits/games_320.png");
    }

    .min-box-container-first, .min-box-container-second {
        height: 87.5vw;
        width: 90vw;

        padding: 6.25vw 6.25vw 0px 6.25vw;
    }

    .med-box-container-first, .med-box-container-second {
        height: 87.5vw;
        width: 90vw;

        padding: 6.25vw 6.25vw 0px 6.25vw;
    }

    .max-box-container-first, .max-box-container-second {
        height: 87.5vw;
        width: 90vw;

        padding: 6.25vw 6.25vw 0px 6.25vw;
    }
}

@media (min-width: 464px) {
    .easy {
        height: 1864px;

        gap: 16px;
    }

    .easy-wrapper {
        gap: 12px;
    }

    .easy-wrapper {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        gap: 12px;
    }

    .es-box-title {
        text-align: center;
        font-size: 17px;
    }

    .es-box-desc {
        text-align: center;
        font-size: 14px;
    }

    .max-box-container-first, .med-box-container-first, .min-box-container-first, .max-box-container-second, .med-box-container-second, .min-box-container-second {
        gap: 12px;
        border-radius: 12px;
        border: 1px solid #222222;
        transition: 0.3s ease;
    }

    .max-box-container-first {
        background-image: url("@/assets/images/benefits/app_mobile.png");
    }

    .max-box-container-second {
        background-image: url("@/assets/images/benefits/subs_mobile.png");
    }

    .med-box-container-first {
        background-image: url("@/assets/images/benefits/library_mobile.png");
    }

    .med-box-container-second {
        background-image: url("@/assets/images/benefits/money_mobile.png");
    }

    .min-box-container-first {
        background-image: url("@/assets/images/benefits/autoinstall_mobile.png");
    }

    .min-box-container-second {
        background-image: url("@/assets/images/benefits/games_mobile.png");
    }

    .min-box-container-first, .min-box-container-second {
        height: 294px;
        width: 464px;

        padding: 24px 24px 0px 24px;
    }

    .med-box-container-first, .med-box-container-second {
        height: 294px;
        width: 464px;

        padding: 24px 24px 0px 24px;
    }

    .max-box-container-first, .max-box-container-second {
        height: 294px;
        width: 464px;

        padding: 24px 24px 0px 24px;
    }
}

@media (min-width: 744px) {
    .easy {
        height: 2338px;

        gap: 24px;
    }

    .easy-wrapper {
        gap: 12px;
    }

    .easy-wrapper {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        gap: 12px;
    }

    .es-box-title {
        text-align: center;
        font-size: 19px;
    }

    .es-box-desc {
        text-align: center;
        font-size: 17px;
    }

    .max-box-container-first, .med-box-container-first, .min-box-container-first, .max-box-container-second, .med-box-container-second, .min-box-container-second {
        gap: 16px;
        border-radius: 12px;
        border: 1px solid #222222;
        transition: 0.3s ease;
    }

    .max-box-container-first {
        background-image: url("@/assets/images/benefits/app_mobile.png");
    }

    .max-box-container-second {
        background-image: url("@/assets/images/benefits/subs_mobile.png");
    }

    .med-box-container-first {
        background-image: url("@/assets/images/benefits/library_mobile.png");
    }

    .med-box-container-second {
        background-image: url("@/assets/images/benefits/money_mobile.png");
    }

    .min-box-container-first {
        background-image: url("@/assets/images/benefits/autoinstall_mobile.png");
    }

    .min-box-container-second {
        background-image: url("@/assets/images/benefits/games_mobile.png");
    }

    .min-box-container-first, .min-box-container-second {
        height: 370px;
        width: 744px;

        padding: 32px 98px 0px 98px;
    }

    .med-box-container-first, .med-box-container-second {
        height: 370px;
        width: 744px;

        padding: 32px 98px 0px 98px;
    }


    .max-box-container-first, .max-box-container-second {
        height: 370px;
        width: 744px;

        padding: 32px 98px 0px 98px;
    }
}

@media (min-width: 984px) {
    .easy {
        height: 1196px;

        gap: 24px;
    }

    .easy-wrapper {
        gap: 12px;
    }

    .easy-wrapper {
        display: flex;
        flex-direction: row;
    }

    .easy-wrapper-container {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        gap: 12px;
    }

    .es-box-title {
        text-align: left;
        font-size: 19px;
    }

    .es-box-desc {
        text-align: left;
        font-size: 17px;
    }

    .max-box-container-first, .med-box-container-first, .min-box-container-first, .max-box-container-second, .med-box-container-second, .min-box-container-second {
        gap: 16px;
        border-radius: 12px;
        border: 1px solid #222222;
        transition: 0.3s ease;
    }

    .max-box-container-first {
        background-image: url("@/assets/images/benefits/app.png");
    }

    .max-box-container-second {
        background-image: url("@/assets/images/benefits/subs.png");
    }

    .med-box-container-first {
        background-image: url("@/assets/images/benefits/library.png");
    }

    .med-box-container-second {
        background-image: url("@/assets/images/benefits/money.png");
    }

    .min-box-container-first {
        background-image: url("@/assets/images/benefits/autoinstall.png");
    }

    .min-box-container-second {
        background-image: url("@/assets/images/benefits/games.png");
    }

    .min-box-container-first, .min-box-container-second {
        height: 370px;
        width: 361px;

        padding: 32px 32px 0px 32px;
    }

    .med-box-container-first, .med-box-container-second {
        height: 370px;
        width: 486px;

        padding: 32px 32px 0px 32px;
    }


    .max-box-container-first, .max-box-container-second {
        height: 370px;
        width: 611px;

        padding: 32px 32px 0px 32px;
    }
}

@media (min-width: 1248px) {
    .easy {
        height: 1483px;

        gap: 32px;
    }

    .easy-wrapper {
        gap: 12px;
    }

    .easy-wrapper {
        display: flex;
        flex-direction: row;
    }

    .easy-wrapper-container {
        display: flex;
        flex-direction: column;
    }

    .easy-wrapper-container {
        gap: 12px;
    }

    .es-box-title {
        font-size: 22px;
    }

    .es-box-desc {
        font-size: 20px;
    }

    .max-box-container-first, .med-box-container-first, .min-box-container-first, .max-box-container-second, .med-box-container-second, .min-box-container-second {
        gap: 16px;
        border-radius: 12px;
        border: 1px solid #222222;
        transition: 0.3s ease;
    }

    .max-box-container-first {
        background-image: url("@/assets/images/benefits/app.png");
    }

    .max-box-container-second {
        background-image: url("@/assets/images/benefits/subs.png");
    }

    .med-box-container-first {
        background-image: url("@/assets/images/benefits/library.png");
    }

    .med-box-container-second {
        background-image: url("@/assets/images/benefits/money.png");
    }

    .min-box-container-first {
        background-image: url("@/assets/images/benefits/autoinstall.png");
    }

    .min-box-container-second {
        background-image: url("@/assets/images/benefits/games.png");
    }

    .min-box-container-first, .min-box-container-second {
        height: 463px;
        width: 460px;

        padding: 40px 40px 0px 40px;
    }

    .med-box-container-first, .med-box-container-second {
        height: 463px;
        width: 618px;

        padding: 40px 40px 0px 40px;
    }

    .max-box-container-first, .max-box-container-second {
        height: 463px;
        width: 776px;

        padding: 40px 40px 0px 40px;
    }
}
</style>